import { auth } from '../firebaseConfig';
import { nativeConsole } from '../utils/logger';

/**
 * Holt den aktuellen Auth-Token für die API-Anfragen
 * @returns Promise mit dem JWT-Token oder null, wenn nicht authentifiziert
 */
export const getAuthToken = async (): Promise<string | null> => {
  try {
    nativeConsole.log('🔐 getAuthToken called');
    const currentUser = auth.currentUser;
    
    nativeConsole.log('👤 Current user:', {
      exists: !!currentUser,
      uid: currentUser?.uid,
      email: currentUser?.email
    });
    
    if (!currentUser) {
      // Versuche, einen gespeicherten Token aus dem Local Storage zu holen
      const storedToken = localStorage.getItem('authToken');
      nativeConsole.log('💾 Stored token:', {
        exists: !!storedToken,
        preview: storedToken ? `${storedToken.substring(0, 30)}...` : 'null'
      });
      
      if (storedToken) {
        return storedToken;
      }
      nativeConsole.log('❌ No user and no stored token');
      return null;
    }
    
    nativeConsole.log('🔄 Getting fresh token...');
    // Hole ein frisches Token
    const token = await currentUser.getIdToken(true);
    
    nativeConsole.log('✅ Fresh token obtained:', {
      length: token.length,
      preview: `${token.substring(0, 30)}...`
    });
    
    // Speichere das Token für spätere Verwendung
    localStorage.setItem('authToken', token);
    
    return token;
  } catch (error) {
    nativeConsole.error('❌ Fehler beim Holen des Auth-Tokens:', error);
    return null;
  }
};

/**
 * Speichert einen Auth-Token im Local Storage
 * @param token Der zu speichernde Token
 */
export const storeAuthToken = (token: string): void => {
  localStorage.setItem('authToken', token);
};

/**
 * Löscht den gespeicherten Auth-Token
 */
export const clearAuthToken = (): void => {
  localStorage.removeItem('authToken');
}; 